export const URL = "https://onlinekart.herokuapp.com"

// export const URL = "http://localhost:5000"